import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { Link as RRRLink } from 'react-router-dom';
import { colors } from '../styles';
import { ButtonDefault } from '../helpers/UIElements';

const styles = css`
  .PageContent_lead {
    margin: 50px 0;
  }
  .list-unstyled, p {
    font-weight: 300;
    font-size: 18px;
    line-height: 35px;
    color: #212529;
  }
  .PageContent_list_item {
    background-color: #F5F5F5;
    padding: 60px;
    margin: 0 0 50px 0;
    &:nth-child(odd) {
     .PageContent_image_wrapper {
        @media (min-width: 992px) {
          order: 1;
        }
      }
    }
  }
  .PageContent_process_info {
    padding: 60px;
    margin: 0 0 0 0;
    flex: 1;
  }
  .PageContent_title {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.8;
    color: rgb(0, 0, 0);
    letter-spacing: 2.5px;
    text-transform: uppercase;
    padding: 0px 0px 30px;
    margin: 0px;
  }
  .PageContent_index {
    background-color: ${colors.color1};
    font-style: normal;
    font-size: 36px;
    line-height: 36px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    padding: 10px;
    margin: 0 0 15px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
  }
  .PageContent_sectiontitle {
    font-size: 42px;
    letter-spacing: 1.31px;
    text-align: center;
    font-weight: 300;
    margin-bottom: 3rem;
  }
  .ProcessList_image {
    float: right;
    margin-left: 30px;
    margin-bottom: 30px;
  }
  .ProcessList_btnWrapper {
    height: 38px;
    width: max-content;
    min-width: 216px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    transition: all .3s ease-out;
    @media(min-width: 768px) {
      height: 53px;
      margin-top: -25px;
    }
    &:hover {
      transform: scale(1.05);
      box-shadow: rgba(0, 0, 0, 0.2) 0px 15px 20px 0px;
    }
    .ProcessList_btn {
      width: 253px;
    }
  }
  .ProcessList_body {
      padding: 20px 0 50px 0;
      } ul {
      padding-left: 0;
      padding-right: 2rem;
      list-style: none;
      }
      ul li::after {
      content: "";
      width: 10px;
      height: 10px;
      background-color: rgb(128, 128, 128);
      position: absolute;
      left: -30px;
      top: 9px;
    }
    .ProcessList_body li {
      text-align: left;
      width: 100%;
      position: relative;
      font-weight: 300;
      font-size: 16px;
      line-height: 28px;
      padding: 0px 0px 20px;
      margin: 0px 0px 0px 30px;
  }
`;

function ProcessList({ content }) {
  return (
    <div className={styles}>
      <div className="container">
        {
          get(content, 'lead_copy') &&
          <div dangerouslySetInnerHTML={SanitizeHtml(get(content, 'lead_copy'))} className="PageContent_lead" />
        }
        <h2 className="PageContent_sectiontitle">{get(content, 'section_title')}</h2>
        <ul className="list-unstyled">
          {
            get(content, 'list').map((item, index) => (
              <li key={item._id} className="d-lg-flex PageContent_list_item">
                <div className="col-lg-6 PageContent_image_wrapper">
                  <Image
                    src={get(item, 'image.contentUrl')}
                    alt={get(item, 'title')}
                    className="w-100"
                  />
                </div>
                <div className="col-lg-6 PageContent_process_info">
                  <h3 className="PageContent_index">{index + 1}.</h3>
                  <h4 className="PageContent_title">{get(item, 'title')}</h4>
                  <div dangerouslySetInnerHTML={SanitizeHtml(get(item, 'lead_copy'))} className="ProcessList_body" />
                  {
                    get(item, 'button_url') &&
                    <div className="ProcessList_btnWrapper mt-4">
                      <ButtonDefault>
                        <RRRLink to={get(item, 'button_url')} className="ProcessList_btn"><span>{get(item, 'button_text')}</span></RRRLink>
                      </ButtonDefault>
                    </div>
                  }
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}
ProcessList.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ProcessList;



// WEBPACK FOOTER //
// ./src/components/ProcessList.js